
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","transform":"matrix(1 0 0 -1 0 26)","fill":"#FCF3F3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.9992 6.5C12.6659 6.5 12.3958 6.79469 12.3958 7.15821V17.2528L8.82937 13.3626C8.59373 13.1055 8.21164 13.1055 7.976 13.3626C7.74029 13.6197 7.74029 14.0364 7.976 14.2935L12.5725 19.3072C12.8082 19.5643 13.1903 19.5643 13.4259 19.3072L18.0225 14.2935C18.2581 14.0364 18.2581 13.6197 18.0225 13.3626C17.7868 13.1055 17.4047 13.1055 17.1691 13.3626L13.6027 17.2528V7.15821C13.6027 6.79469 13.3325 6.5 12.9992 6.5Z","fill":"#DD3B3B"}})])
          )
        }
      }
    